import styled from 'styled-components';
import { dots } from 'styles/animations';

const LoadingDots = styled.span<{ dotColor?: string }>`
  &:after {
    color: ${props => props.dotColor || props.theme.colors.deepGrey};
    content: ' .';
    ${dots}
  }
`;

export { LoadingDots };
